import { MouseEventHandler } from 'react';
import styled from 'styled-components/macro';

import MUILink from '@mui/material/Link';

import { TextStyle } from 'ev-components/Text';

export type LinkVariant = 'body' | 'description' | 'footnote';

type LinkProps = {
  children?: React.ReactNode;
  id: string;
  href?: string;
  download?: boolean | string;
  boldText?: boolean;
  onClick?: MouseEventHandler;
  underlined?: boolean;
  variant?: LinkVariant;
  className?: string;
};

const Link = ({
  href,
  onClick,
  id,
  children,
  download = false,
  underlined = false,
  variant = 'body',
  boldText,
  className,
}: LinkProps) => {
  return (
    <Anchor
      $bold={boldText}
      $variant={variant}
      className={className}
      data-testid={id}
      download={download}
      href={href}
      onClick={onClick}
      target="_blank"
      underline={underlined ? 'always' : 'none'}
    >
      {children}
    </Anchor>
  );
};

export default Link;

const Anchor = styled(MUILink)<{ $variant: LinkVariant; $bold?: boolean }>`
  cursor: pointer;
  .MuiLink-underlineAlways {
    text-decoration: underline;
  }
  ${({ $variant, $bold }) => {
    switch ($variant) {
      case 'description':
        return $bold
          ? TextStyle.SemiBold.Description
          : TextStyle.Regular.Description;
      case 'footnote':
        return $bold ? TextStyle.SemiBold.Footnote : TextStyle.Regular.Footnote;
      default:
        return $bold ? TextStyle.SemiBold.Body : TextStyle.Regular.Body;
    }
  }}
`;
